module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alanModal"
  }, [_c('Modal', {
    staticClass: "defaultModal",
    attrs: {
      "width": "500px",
      "closable": false,
      "mask-closable": false,
      "class-name": "vertical-center-modal"
    },
    model: {
      value: (_vm.defaultModal),
      callback: function($$v) {
        _vm.defaultModal = $$v
      },
      expression: "defaultModal"
    }
  }, [_c('div', {
    staticClass: "defaultModal_content",
    class: {
      'success': _vm.defaultModalContent.status === 'success',
        'warning': _vm.defaultModalContent.status === 'warning',
        'confim': _vm.defaultModalContent.status === 'confim',
    },
    domProps: {
      "innerHTML": _vm._s(_vm.defaultModalContent.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "defaultModal_bottom"
  }, [(_vm.defaultModalContent.status !== 'confim') ? _c('span', {
    on: {
      "click": function($event) {
        _vm.setData({
          key: 'defaultModal',
          value: false
        });
        _vm.defaultModalContent.onOk && _vm.defaultModalContent.onOk()
      }
    }
  }, [_vm._v("关闭")]) : _vm._e(), _vm._v(" "), (_vm.defaultModalContent.status === 'confim') ? _c('span', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.setData({
          key: 'defaultModal',
          value: false
        });
        _vm.defaultModalContent.onCancel && _vm.defaultModalContent.onCancel()
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.defaultModalContent.status === 'confim') ? _c('span', {
    staticClass: "ok",
    on: {
      "click": function($event) {
        _vm.setData({
          key: 'defaultModal',
          value: false
        });
        _vm.defaultModalContent.onOk()
      }
    }
  }, [_vm._v("确认")]) : _vm._e()])]), _vm._v(" "), _c('Modal', {
    staticClass: "defaultModal openLotteryModal",
    attrs: {
      "width": "500px",
      "closable": false,
      "mask-closable": false,
      "class-name": "vertical-center-modal"
    },
    model: {
      value: (_vm.openLotteryModal),
      callback: function($$v) {
        _vm.openLotteryModal = $$v
      },
      expression: "openLotteryModal"
    }
  }, [_c('div', {
    staticClass: "defaultModal_content",
    class: {
      'success': _vm.openLottery.status === 'success',
        'warning': _vm.openLottery.status === 'warning'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.openLottery.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "defaultModal_bottom"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.setData({
          key: 'openLotteryModal',
          value: false
        });
        _vm.openScroll()
      }
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('Modal', {
    staticClass: "ssc_animation",
    class: {
      'Narrow': _vm.sscNarrow
    },
    attrs: {
      "width": "800px",
      "closable": false,
      "mask-closable": false
    },
    model: {
      value: (_vm.ssc_openLotteryAnimation),
      callback: function($$v) {
        _vm.ssc_openLotteryAnimation = $$v
      },
      expression: "ssc_openLotteryAnimation"
    }
  }, [(_vm.ssc_openLotteryAnimation) ? _c('div', {
    staticClass: "ssc_animation_content"
  }, [_c('div', {
    staticClass: "ssc_video"
  }, [_c('video', {
    attrs: {
      "loop": "loop",
      "autoplay": "",
      "src": "/static/img/lottery/ssc_openVideo.mp4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "openCode"
  }, [(_vm.sscDataModal.openCode) ? _c('div', {
    staticClass: "ballBox"
  }, _vm._l((_vm.sscDataModal.openCode.split(',')), function(v, i) {
    return _c('span', {
      key: i
    }, [_vm._v(_vm._s(v))])
  }), 0) : _vm._e()]), _vm._v(" "), _c('img', {
    staticClass: "normalImg",
    attrs: {
      "src": ("/static/img/lottery/" + (!_vm.sscNarrow?'sscClose':'sscOpen') + ".png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.sscNarrow = !_vm.sscNarrow;
        _vm.openScroll()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        return _vm.setData({
          key: 'ssc_openLotteryAnimation',
          value: false
        })
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('Modal', {
    staticClass: "modal_bettingNow",
    attrs: {
      "title": _vm.bettingContent.title,
      "closable": false,
      "mask-closable": false,
      "class-name": "vertical-center-modal",
      "width": "500px"
    },
    model: {
      value: (_vm.modal_bettingNow),
      callback: function($$v) {
        _vm.modal_bettingNow = $$v
      },
      expression: "modal_bettingNow"
    }
  }, [_c('p', {
    staticClass: "issue"
  }, [_vm._v("您确认加入第"), _c('span', [_vm._v(_vm._s(_vm.issue))]), _vm._v("期？")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('p', [_vm._v("总注数："), _c('span', [_vm._v(_vm._s(_vm.bettingContent.data ? _vm.bettingContent.data.note : _vm.note))])]), _vm._v(" "), _c('p', [_vm._v("投注总额："), _c('span', [_vm._v(_vm._s(_vm.bettingContent.data ? _vm.bettingContent.data.total : _vm.total) + "元")])]), _vm._v(" "), _c('p', [_vm._v("是否追号："), _c('span', [_vm._v("否")])]), _vm._v(" "), _c('p', [_vm._v("订单笔数："), _c('span', [_vm._v(_vm._s(1))])])]), _vm._v(" "), _c('p', {
    staticClass: "prompt"
  }, [_c('span', [_vm._v("温馨提示：")]), _vm._v("本期最高奖金限额"), _c('span', [_vm._v(_vm._s(_vm.bettingContent.data ? _vm.bettingContent.data.maxBouns : _vm.maxBouns))]), _vm._v("元，请会员谨慎投注！\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "defaultModal_bottom"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.setData({
          key: 'modal_bettingNow',
          value: false
        });
        _vm.bettingContent.onCancel && _vm.bettingContent.onCancel()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "ok",
    on: {
      "click": function($event) {
        _vm.setData({
          key: 'modal_bettingNow',
          value: false
        }), _vm.bettingContent.onOk()
      }
    }
  }, [_vm._v("确认投注")])])]), _vm._v(" "), _c('Modal', {
    staticClass: "modal_bettingNow",
    attrs: {
      "title": _vm.jdBettingList.title,
      "closable": false,
      "mask-closable": false,
      "class-name": "vertical-center-modal",
      "width": "500px"
    },
    model: {
      value: (_vm.jd_betting),
      callback: function($$v) {
        _vm.jd_betting = $$v
      },
      expression: "jd_betting"
    }
  }, [_c('p', {
    staticClass: "issue"
  }, [_vm._v("您确认加入第"), _c('span', [_vm._v(_vm._s(_vm.issue))]), _vm._v("期？")]), _vm._v(" "), _c('div', {
    staticClass: "jd-info"
  }, _vm._l((_vm.jdBettingList.data.list), function(item) {
    return _c('span', {
      staticClass: "jd-item"
    }, [_vm._v(_vm._s(item.gname) + " 【" + _vm._s(item.BetContext) + "】 @" + _vm._s(item.rate ? item.rate : item.Lines) + " x " + _vm._s(item.Money))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "total-note"
  }, [_vm._v("\n        共计:"), _c('span', [_vm._v("￥" + _vm._s(_vm.jdBettingList.data.note) + "/" + _vm._s(_vm.jdBettingList.data.total))]), _vm._v(",您确认要下注吗?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "defaultModal_bottom"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.setData({
          key: 'jd_betting',
          value: false
        });
        _vm.jdBettingList.onCancel && _vm.jdBettingList.onCancel()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "ok",
    on: {
      "click": function($event) {
        _vm.setData({
          key: 'jd_betting',
          value: false
        }), _vm.jdBettingList.onOk()
      }
    }
  }, [_vm._v("确认投注")])])]), _vm._v(" "), _c('Modal', {
    staticClass: "defaultModalH5",
    attrs: {
      "closable": false,
      "mask-closable": false,
      "class-name": "vertical-center-modal"
    },
    model: {
      value: (_vm.H5DefaultModal),
      callback: function($$v) {
        _vm.H5DefaultModal = $$v
      },
      expression: "H5DefaultModal"
    }
  }, [_c('div', {
    staticClass: "defaultModal_content",
    class: {
      'success-h5': _vm.defaultModalContent.status === 'success-h5',
    }
  }, [_vm._v(_vm._s(_vm.defaultModalContent.content) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "defaultModal_bottom"
  }, [(_vm.defaultModalContent.status !== 'confim') ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.setData({
          key: 'H5DefaultModal',
          value: false
        })
      }
    }
  }, [_vm._v("关闭")]) : _vm._e(), _vm._v(" "), (_vm.defaultModalContent.status === 'confim') ? _c('span', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.setData({
          key: 'H5DefaultModal',
          value: false
        });
        _vm.defaultModalContent.onCancel && _vm.defaultModalContent.onCancel()
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.defaultModalContent.status === 'confim') ? _c('span', {
    staticClass: "ok",
    on: {
      "click": function($event) {
        _vm.setData({
          key: 'H5DefaultModal',
          value: false
        });
        _vm.defaultModalContent.onOk()
      }
    }
  }, [_vm._v("确认")]) : _vm._e()])]), _vm._v(" "), _c('Modal', {
    staticClass: "newPersonModal",
    attrs: {
      "closable": false,
      "mask-closable": false
    },
    model: {
      value: (_vm.newPersonModal),
      callback: function($$v) {
        _vm.newPersonModal = $$v
      },
      expression: "newPersonModal"
    }
  }, [_c('div', {
    staticClass: "taskClose",
    on: {
      "click": function($event) {
        _vm.setData({
          key: 'newPersonModal',
          value: false
        });
        _vm.userNames = '';
        _vm.phoneNum = '';
        _vm.imgYzCode = '';
        _vm.yzCode = '';
        _vm.isCaptcha = false;
        _vm.send_code_error = ''
      }
    }
  }, [_vm._v("\n        关闭\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "taskContent"
  }, [('填写真实姓名' == _vm.defaultModalContent.taskTitle) ? _c('h3', [_vm._v("填写真实姓名")]) : _vm._e(), _vm._v(" "), ('填写微信号' == _vm.defaultModalContent.taskTitle) ? _c('h3', [_vm._v("填写微信号")]) : _vm._e(), _vm._v(" "), ('填写手机号' == _vm.defaultModalContent.taskTitle) ? _c('h3', [_vm._v("填写手机号")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "taskMain"
  }, [('bindName' == _vm.defaultModalContent.typeNow) ? _c('div', {
    staticClass: "taskInput"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userNames),
      expression: "userNames"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入您的真实姓名"
    },
    domProps: {
      "value": (_vm.userNames)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userNames = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), ('bindWechat' == _vm.defaultModalContent.typeNow) ? _c('div', {
    staticClass: "taskInput"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userNames),
      expression: "userNames"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入您的微信号"
    },
    domProps: {
      "value": (_vm.userNames)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userNames = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), ('bindName' == _vm.defaultModalContent.typeNow) ? _c('div', {
    staticClass: "taskBtn"
  }, [_c('span', {
    class: _vm.verficationUserNames && _vm.userNames != '' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.verficationUserNames && _vm.userNames != '' && _vm.setName()
      }
    }
  }, [_vm._v("确定")])]) : _vm._e(), _vm._v(" "), ('bindWechat' == _vm.defaultModalContent.typeNow) ? _c('div', {
    staticClass: "taskBtn"
  }, [_c('span', {
    class: _vm.verficationweChatNum && _vm.userNames != '' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.verficationweChatNum && _vm.userNames != '' && _vm.setWechat()
      }
    }
  }, [_vm._v("确定")])]) : _vm._e(), _vm._v(" "), ('bindMobile' == _vm.defaultModalContent.typeNow) ? _c('div', {
    staticClass: "taskPhone"
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "phoneType"
  }, [_c('div', {
    staticClass: "country"
  }, [_vm._v("国家/地区")]), _vm._v(" "), _c('div', {
    staticClass: "countryType"
  }, [_c('Select', {
    on: {
      "on-change": _vm.selOption
    },
    model: {
      value: (_vm.countryType),
      callback: function($$v) {
        _vm.countryType = $$v
      },
      expression: "countryType"
    }
  }, _vm._l((_vm.phoneTypeList), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "phoneMain"
  }, [_c('div', {
    staticClass: "countryNum"
  }, [_vm._v(_vm._s(_vm.phoneType))]), _vm._v(" "), _c('div', {
    staticClass: "phoneInput"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNum),
      expression: "phoneNum"
    }],
    class: _vm.alreadyPhone ? 'inputErr' : '',
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.phoneNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNum = $event.target.value
      }, function($event) {
        _vm.verificationMobile && _vm.regCheckphone();
        _vm.isCountFinish = false;
        _vm.send_code_error = '';
        _vm.alreadyPhone = false
      }]
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.alreadyPhone && _vm.phoneNum != '' && _vm.verificationMobile),
      expression: "!alreadyPhone&&phoneNum!=''&&verificationMobile"
    }],
    staticClass: "icon_v3 success"
  }, [_vm._v("")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alreadyPhone && _vm.phoneNum != ''),
      expression: "alreadyPhone&&phoneNum!=''"
    }],
    staticClass: "icon_v3 error",
    on: {
      "click": function($event) {
        _vm.phoneNum = '';
        _vm.send_code_error = ''
      }
    }
  }, [_vm._v("")])])]), _vm._v(" "), (_vm.isCaptcha) ? _c('div', {
    staticClass: "codeMain",
    staticStyle: {
      "border-bottom": "1px solid #ddd"
    }
  }, [_c('div', {
    staticClass: "codeText"
  }, [_vm._v("图片验证码：")]), _vm._v(" "), _c('div', {
    staticClass: "codeInput"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgYzCode),
      expression: "imgYzCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "输入图片验证码"
    },
    domProps: {
      "value": (_vm.imgYzCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.imgYzCode = $event.target.value
      }, function($event) {
        _vm.isCountFinish = false;
        _vm.send_code_error = ''
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "codeBtn",
    on: {
      "click": _vm.RefreshSrc
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.safetySrc,
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "codeMain"
  }, [_c('div', {
    staticClass: "codeText"
  }, [_vm._v("验证码：")]), _vm._v(" "), _c('div', {
    staticClass: "codeInput"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yzCode),
      expression: "yzCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.yzCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.yzCode = $event.target.value
      }, function($event) {
        _vm.send_code_error = ''
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "codeBtn"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCountFinish),
      expression: "!isCountFinish"
    }],
    staticClass: "getCode",
    on: {
      "click": function($event) {
        !_vm.alreadyPhone && _vm.verificationMobile && _vm.getCode()
      }
    }
  }, [_vm._v("获取验证码")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCountFinish),
      expression: "isCountFinish"
    }],
    staticClass: "getCode"
  }, [_vm._v("剩余" + _vm._s(_vm.countTime) + "s")])])]), _vm._v(" "), _c('div', {
    class: _vm.send_code_error != '' ? 'inputErrtips' : ''
  }, [_vm._v(_vm._s(_vm.send_code_error))])]) : _vm._e(), _vm._v(" "), ('bindMobile' == _vm.defaultModalContent.typeNow) ? _c('div', {
    staticClass: "taskBtn"
  }, [_c('span', {
    class: _vm.verificationMobile && _vm.verificationMobileCode && _vm.yzCode != '' && !_vm.alreadyPhone ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.verificationMobile && _vm.verificationMobileCode && _vm.yzCode != '' && !_vm.alreadyPhone && _vm.setPhone()
      }
    }
  }, [_vm._v("确定")])]) : _vm._e()])]), _vm._v(" "), _c('Modal', {
    staticClass: "newPersonBonus",
    attrs: {
      "closable": false,
      "mask-closable": false
    },
    model: {
      value: (_vm.newPersonBonus),
      callback: function($$v) {
        _vm.newPersonBonus = $$v
      },
      expression: "newPersonBonus"
    }
  }, [_c('div', {
    staticClass: "bonusClose",
    on: {
      "click": function($event) {
        _vm.setData({
          key: 'newPersonBonus',
          value: false
        });
        _vm.userNames = '';
        _vm.phoneNum = '';
        _vm.imgYzCode = '';
        _vm.yzCode = '';
        _vm.isCaptcha = false;
        _vm.send_code_error = ''
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('div', {
    staticClass: "bonusContent"
  }, [_c('div', {
    class: _vm.defaultModalContent.bonus ? 'carry' : ''
  }, [_vm._v("¥"), _c('span', [_vm._v(_vm._s(_vm.defaultModalContent.nowBonus))])])]), _vm._v(" "), (!_vm.defaultModalContent.Content) ? _c('div', {
    staticClass: "bonusMain"
  }, [_c('div', {
    staticClass: "bonusBtn goBet",
    on: {
      "click": _vm.goBetting
    }
  }, [_vm._v("点击使用")]), _vm._v(" "), _c('div', {
    staticClass: "bonusBtn carryOn",
    on: {
      "click": _vm.carryOn
    }
  }, [_vm._v("再领 " + _vm._s(_vm.defaultModalContent.nextBonus) + " 元")])]) : _vm._e(), _vm._v(" "), (!_vm.defaultModalContent.Content) ? _c('div', {
    staticClass: "bonusBottom"
  }, [_c('div', {
    staticClass: "bonusBottomBtn",
    on: {
      "click": function () { return (this$1.$router.push('/lottery/#11')); }
    }
  }, [_vm._v("跳转投注页开始投注吧!")]), _vm._v(" "), _c('div', {
    staticClass: "bonusBottomBtn",
    on: {
      "click": _vm.carryOn
    }
  }, [_vm._v("继续完成任务，领取大奖!")])]) : _vm._e(), _vm._v(" "), (_vm.defaultModalContent.Content) ? _c('div', {
    staticClass: "bonusMain",
    staticStyle: {
      "margin-top": "-6px"
    }
  }, [_c('div', {
    staticClass: "tatalMain"
  }, [_vm._v("恭喜您总共获得"), _c('span', [_vm._v("¥" + _vm._s(_vm.defaultModalContent.setTotal))]), _vm._v("红包")])]) : _vm._e(), _vm._v(" "), (_vm.defaultModalContent.Content) ? _c('div', {
    staticClass: "bonusMain",
    staticStyle: {
      "height": "60px",
      "margin-top": "0"
    }
  }, [_c('div', {
    staticClass: "bounsText"
  }, [_vm._v("恭喜玩家您已经领取了金洋在线送给您的新手大礼包，快来开始游戏吧！")])]) : _vm._e(), _vm._v(" "), (_vm.defaultModalContent.Content) ? _c('div', {
    staticClass: "bonusMain"
  }, [_c('div', {
    staticClass: "bonusBtn carryOn",
    on: {
      "click": function () { return (this$1.$router.push('/lottery/#11')); }
    }
  }, [_vm._v("游戏投注")])]) : _vm._e()]), _vm._v(" "), _c('Modal', {
    staticClass: "modal_orderDetail",
    attrs: {
      "width": "800",
      "closable": false,
      "mask-closable": false,
      "title": "订单详情"
    },
    model: {
      value: (_vm.modal_orderDetail),
      callback: function($$v) {
        _vm.modal_orderDetail = $$v
      },
      expression: "modal_orderDetail"
    }
  }, [(_vm.modal_orderDetailTable) ? _c('div', {
    staticClass: "orderDetail_table"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("订单编号")]), _c('span', {
    staticClass: "col2"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.billno))]), _c('span', {
    staticClass: "col3"
  }, [_vm._v("状态")]), _c('span', {
    staticClass: "col4"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.statusRemark))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("彩种")]), _c('span', {
    staticClass: "col2"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.lottery))]), _c('span', {
    staticClass: "col3"
  }, [_vm._v("期号")]), _c('span', {
    staticClass: "col4"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.issue) + "期")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("玩法")]), _c('span', {
    staticClass: "col2"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.method))]), _c('span', {
    staticClass: "col3"
  }, [_vm._v("注数")]), _c('span', {
    staticClass: "col4"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.nums) + "注")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("资金模式")]), _c('span', {
    staticClass: "col2"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.model))]), _c('span', {
    staticClass: "col3"
  }, [_vm._v("倍数")]), _c('span', {
    staticClass: "col4"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.multiple) + "倍")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("奖金模式")]), _c('span', {
    staticClass: "col2"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.code))]), _c('span', {
    staticClass: "col3"
  }, [_vm._v("返点")]), _c('span', {
    staticClass: "col4"
  }, [_vm._v(_vm._s(Number(_vm.modal_orderDetailTable.point).toFixed(1)) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("投注金额")]), _c('span', {
    staticClass: "col2"
  }, [_vm._v("¥ " + _vm._s(Number(_vm.modal_orderDetailTable.money).toFixed(3)))]), _c('span', {
    staticClass: "col3"
  }, [_vm._v("中奖金额")]), _c('span', {
    staticClass: "col4"
  }, [_vm._v("¥ " + _vm._s(Number(_vm.modal_orderDetailTable.winMoney).toFixed(3)))])]), _vm._v(" "), _c('div', {
    staticClass: "item item_row"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("下单时间")]), _c('span', {
    staticClass: "col2"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.orderTime))])]), _vm._v(" "), _c('div', {
    staticClass: "item item_row"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("开奖号码")]), _c('span', {
    staticClass: "col2"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.openCode ? _vm.modal_orderDetailTable.openCode : '无'))])]), _vm._v(" "), _c('div', {
    staticClass: "item item_row table_bottm"
  }, [_c('div', {
    staticClass: "col1"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("投注内容")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.order_print()
      }
    }
  }, [_vm._v("打印")])]), _vm._v(" "), (_vm.modal_orderDetailTable.lottery) ? _c('div', {
    staticClass: "col2 openCode"
  }, [_vm._v("\n            " + _vm._s(_vm.modal_orderDetailTable.lottery.includes('11选5') ? _vm.modal_orderDetailTable.content.replace(/,/g, '').replace(/\|/g, ',') : _vm.modal_orderDetailTable.content) + "\n          ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        return _vm.close_orderDetail()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "ok",
    on: {
      "click": function($event) {
        return _vm.ok_orderDetail(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable && _vm.modal_orderDetailTable.allowCancel ? '撤销订单' : '确定'))])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "printnow"
    }
  }), _vm._v(" "), _c('Modal', {
    staticClass: "modal_orderDetail",
    attrs: {
      "width": "800",
      "title": "订单详情",
      "closable": false,
      "mask-closable": false,
      "okText": _vm.modal_orderDetailTable && _vm.modal_orderDetailTable.allowCancel ? '撤销订单' : '确定'
    },
    on: {
      "on-ok": function($event) {
        _vm.modal_orderDetailTable && _vm.modal_orderDetailTable.allowCancel && _vm.Withdrawal(_vm.modal_orderDetailTable, 2)
      },
      "on-cancel": function($event) {
        _vm.modal_chaseDetailTabIndex = 0
      }
    },
    model: {
      value: (_vm.modal_chaseDetail),
      callback: function($$v) {
        _vm.modal_chaseDetail = $$v
      },
      expression: "modal_chaseDetail"
    }
  }, [_c('div', {
    staticClass: "tab"
  }, _vm._l((_vm.modal_chaseDetailTab), function(v, i) {
    return _c('span', {
      key: i,
      class: {
        'active': _vm.modal_chaseDetailTabIndex === i
      },
      on: {
        "click": function($event) {
          _vm.modal_chaseDetailTabIndex = i
        }
      }
    }, [_vm._v(_vm._s(v))])
  }), 0), _vm._v(" "), (_vm.modal_orderDetailTable && _vm.modal_chaseDetailTabIndex === 0) ? _c('div', {
    staticClass: "orderDetail_table"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("订单编号")]), _c('span', {
    staticClass: "col2"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.billno))]), _c('span', {
    staticClass: "col3"
  }, [_vm._v("状态")]), _c('span', {
    staticClass: "col4"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.statusStr))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("彩种")]), _c('span', {
    staticClass: "col2"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.lottery))]), _c('span', {
    staticClass: "col3"
  }, [_vm._v("玩法")]), _c('span', {
    staticClass: "col4"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.method))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("开始期号")]), _c('span', {
    staticClass: "col2"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.startIssue) + "期")]), _c('span', {
    staticClass: "col3"
  }, [_vm._v("注数")]), _c('span', {
    staticClass: "col4"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.nums) + "注")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("总期数")]), _c('span', {
    staticClass: "col2"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.totalCount))]), _c('span', {
    staticClass: "col3"
  }, [_vm._v("已追期数")]), _c('span', {
    staticClass: "col4"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.clearCount))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("资金模式")]), _c('span', {
    staticClass: "col2"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.model))]), _c('span', {
    staticClass: "col3"
  }, [_vm._v("返点")]), _c('span', {
    staticClass: "col4"
  }, [_vm._v(_vm._s(Number(_vm.modal_orderDetailTable.point).toFixed(1)) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("总金额")]), _c('span', {
    staticClass: "col2"
  }, [_vm._v("¥ " + _vm._s(Number(_vm.modal_orderDetailTable.totalMoney).toFixed(3)))]), _c('span', {
    staticClass: "col3"
  }, [_vm._v("总奖金")]), _c('span', {
    staticClass: "col4"
  }, [_vm._v("¥ " + _vm._s(Number(_vm.modal_orderDetailTable.winMoney).toFixed(3)))])]), _vm._v(" "), _c('div', {
    staticClass: "item item_row"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("下单时间")]), _c('span', {
    staticClass: "col2"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.orderTime))])]), _vm._v(" "), _c('div', {
    staticClass: "item item_row"
  }, [_c('span', {
    staticClass: "col1"
  }, [_vm._v("中单是否撤单")]), _c('span', {
    staticClass: "col2"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.winStop ? '是' : '否'))])]), _vm._v(" "), _c('div', {
    staticClass: "item item_row table_bottm"
  }, [_c('div', {
    staticClass: "col1"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("投注内容")])]), _vm._v(" "), _c('div', {
    staticClass: "col2"
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable.content))])])]) : _vm._e(), _vm._v(" "), (_vm.modal_orderDetailTable && _vm.modal_chaseDetailTabIndex === 1) ? _c('div', {
    staticClass: "everyIssue_table"
  }, [_c('ul', {
    staticClass: "everyIssue_tableTop",
    class: {
      'isScroll': _vm.modal_orderDetailTable.chaseList && _vm.modal_orderDetailTable.chaseList.length > 7
    }
  }, _vm._l((_vm.everyIssue_tableTop), function(v, i) {
    return _c('li', {
      key: i
    }, [_vm._v(_vm._s(v))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "everyIssue_tableContentBox"
  }, _vm._l((_vm.modal_orderDetailTable.chaseList), function(v, i) {
    return _c('ul', {
      key: i
    }, [_c('li', [_vm._v(_vm._s(v.issue))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(v.multiple))]), _vm._v(" "), _c('li', [_vm._v("¥ " + _vm._s(Number(v.money).toFixed(3)))]), _vm._v(" "), _c('li', [_vm._v("¥ " + _vm._s(Number(v.winMoney).toFixed(3)))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(v.statusRemark))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(v.openCode ? v.openCode : '无'))]), _vm._v(" "), _c('li', {
      class: {
        'back': v.allowCancel
      },
      on: {
        "click": function($event) {
          v.allowCancel && _vm.Withdrawal(v, 3)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(v.allowCancel ? '撤销' : '无操作'))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        return _vm.close_orderDetail()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "ok",
    on: {
      "click": function($event) {
        return _vm.ok_orderDetail(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.modal_orderDetailTable && _vm.modal_orderDetailTable.allowCancel ? '撤销订单' : '确定'))])])]), _vm._v(" "), _c('Modal', {
    staticClass: "thridTransfer_Modal",
    attrs: {
      "width": "650",
      "height": "390",
      "title": "余额转账",
      "closable": false,
      "mask-closable": false
    },
    model: {
      value: (_vm.thridTransfer_Modal),
      callback: function($$v) {
        _vm.thridTransfer_Modal = $$v
      },
      expression: "thridTransfer_Modal"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.setData({
          key: 'thridTransfer_Modal',
          value: false
        });
        _vm.money = '';
        _vm.errTips = '';
        _vm.directionIndex = 0
      }
    }
  }, [_vm._v("\n        ×\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "thridTransfer_Main"
  }, [_c('div', {
    staticClass: "thridTransferType"
  }, _vm._l((_vm.direction), function(v, i) {
    return _c('span', {
      key: i,
      class: {
        'active': _vm.directionIndex === i
      },
      on: {
        "click": function($event) {
          _vm.directionIndex = i;
          _vm.money = ''
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(v.label) + "\n\t\t\t\t\t")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "thridTransferInput"
  }, [_vm._v("可转入金额: "), _c('span', [_vm._v(_vm._s(_vm.directionIndex === 1 ? Math.floor(_vm.defaultModalContent.money) : Math.floor(_vm.baseInfo.lotteryBalance)))]), _c('em', [_vm._v("元")])]), _vm._v(" "), _c('div', {
    staticClass: "write"
  }, [_vm._v("转入金额："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.money),
      expression: "money"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.money)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.money = $event.target.value
      }, function($event) {
        _vm.errTips = ''
      }]
    }
  }), _c('span', {
    on: {
      "click": function($event) {
        _vm.money = Math.floor(_vm.directionIndex === 1 ? _vm.defaultModalContent.money : _vm.baseInfo.lotteryBalance)
      }
    }
  }, [_vm._v("全部转入")]), _vm._v(" "), _c('em', [_vm._v("元")])]), _vm._v(" "), _c('div', {
    staticClass: "errTips"
  }, [_c('p', [_vm._v(_vm._s(_vm.errTips))])]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    class: {
      'noClick': !_vm.money
    },
    on: {
      "click": function($event) {
        _vm.money > 0 && _vm.thridTransfer()
      }
    }
  }, [_vm._v("确定转入")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1e85bc05"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/lotteryRefactoring/alanModal.vue
// module id = 886
// module chunks = 9